import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import Placeholder from "@/pages/Placeholder";
import About from "@/pages/About";
import RidingTherapy from "@/pages/RidingTherapy";
import Volunteering from "@/pages/Volunteering";
import FacilityHire from "@/pages/FacilityHire";
import SupportUs from "@/pages/SupportUs";
import Vacancies from "@/pages/Vacancies";
import Gallery from "@/pages/Gallery";
import News from "@/pages/News";
import NewsArticle from "@/pages/NewsArticle";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/riding-therapy" element={<RidingTherapy />} />
            <Route path="/volunteering" element={<Volunteering />} />
            <Route path="/facility-hire" element={<FacilityHire />} />
            <Route path="/support-us" element={<SupportUs />} />
            <Route path="/vacancies" element={<Vacancies />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:slug" element={<NewsArticle />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
